import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import { autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { AppMessageService } from "../services/app-message-service";
import { DialogService } from "aurelia-dialog";
import { PageMessageService } from "../services/page-message-service";
import { SecurityService } from "../services/security-service"; 6
import { TaskActionService } from "./requests/TaskActionService";
import { UiActionButton } from "./requests/UiActionButton";
import { IFulfillmentWidget } from "./requests/new-user-request/new-user-request-fulfillment";
import { CmpTaskDto } from "../data/typegen/dtos/cmp-task-dto";
import { DisplayValuePair } from "../data/typegen/dtos/display-value-pair";
import { TaskState } from "../data/enums/taskState";
import { RequestDto } from "../data/typegen/dtos/request-dto";
import { DoUiActionDto } from "../data/typegen/dtos/do-ui-action-dto";
import { CmpTaskBaseDto } from "../data/typegen/dtos/cmp-task-base-dto";
import { RequestTypeIds } from "../data/typegen/enums/request-type-ids";
import { validateTrigger, ValidationController, ValidationControllerFactory } from "aurelia-validation";
import { DefaultValidationRenderer } from "../resources/renderers/default-validation-renderer";
import { Router } from 'aurelia-router';
import { ActivityStreamItemBase } from "../data/typegen/dtos/activity-stream-item-base";
import { TaskDetailsScreenDataDto } from "../data/typegen/dtos/task-details-screen-data-dto";

@singleton()
@autoinject()
export class TaskDetails {

    public task: CmpTaskDto;
    public request: RequestDto;
    public activityStream: Array<ActivityStreamItemBase> = [];
    public assignedToUsers: Array<DisplayValuePair<string>> = [];
    public taskDetailsComponent: IFulfillmentWidget;
    public taskState = TaskState;
    private originalTask: CmpTaskDto;

    private saveUiAction: UiActionButton;
    private closeUiAction: UiActionButton;
    private startWorkAction: UiActionButton;
    public requestTypeIds = RequestTypeIds;
    controller: ValidationController = null;

    constructor(
        private controllerFactory: ValidationControllerFactory,
        private taskActionService: TaskActionService,
        private securityService: SecurityService,
        private busyService: BusyService,
        private appMsg: AppMessageService,
        private msg: PageMessageService,
        private dialogService: DialogService,
        private router: Router,
        private api: WebApiService) {
        this.controller = controllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.change;
        this.controller.addRenderer(new DefaultValidationRenderer());
    }

    public canModifyState: boolean;

    async activate(params) {
        var contractsAndInsuranceLeadsGroupId = "a86a7675-52ab-401e-b8a2-aaca50c7ffdc";
        const isContractsAndInsuranceLeadsMember = this.securityService.hasGroup(contractsAndInsuranceLeadsGroupId);
        this.canModifyState = this.securityService.hasRole("admin") || isContractsAndInsuranceLeadsMember;
        this.taskActionService.actionButtons.length = 0;
        await this.loadDataAsync(params.id);
    }


    public attached() {

        setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 100);
        this.updateUiActions();
    }

    fixVerticalTabindex(selector) {
        var tabindex = 1;
        jQuery(selector).each(function (i, tbl) {
            jQuery(tbl).find('.row>div[class*="col"]:last-child').each(function (j, col) {
                jQuery(col).find('input,select,textarea').each(function (j, obj) {
                    jQuery(obj).attr('tabindex', tabindex++);
                });
            });
        });
    }

    async refresh() {
        await this.loadDataAsync(this.task.taskId);
        await this.taskDetailsComponent.initUi();
        this.updateUiActions();
    }


    public async doAction(uiAction: UiActionButton, validate = true) {
        this.msg.clear();
        this.appMsg.clearPageScopedMessages();
        var action = new DoUiActionDto<CmpTaskBaseDto>();
        action.taskDto = this.task;
        action.uiActionVerb = uiAction.key;
        let performValidation = uiAction.performValidation;
        if (this.startWorkAction && action.uiActionVerb == this.startWorkAction.key) {
            this.task.state.value = TaskState.InProgress;
            this.task.assignedTo.value = this.securityService.user.id;
        }
        else if (action.uiActionVerb == this.closeUiAction.key) {
            this.task.state.value = TaskState.ClosedComplete;
        }
        else {
            const result = await this.taskDetailsComponent.doAction(action);
            if (result.submit != true) {
                if (result.reload == true) {
                    await this.loadDataAsync(this.task.taskId);
                }
                return;
            }else{
                if( result.performValidation === false){
                    performValidation = false;
                }
            }
        }

        if (uiAction.triggersSubmit) {
            // Master Approve Carrier
            if (action.uiActionVerb == "set_master_approved") {
                if (!confirm("Are you sure you want to Master Approve this carrier?  This will send an approval email to all users who are configured to receive Carrier Reports.")) {
                    return;
                }
            }
            
            // Deny Carrier
            if (action.uiActionVerb == "final_deny") {
                if (!confirm("Are you sure you want to Deny this carrier?  The request will be cancelled and the carrier status will be set to Closed-Incomplete")) {
                    return;
                }
            }

            var isValid = !performValidation || !validate || !uiAction.performValidation || await this.runValidationRules();
            if (isValid) {
                await this.submitUiAction(action, uiAction.redirectAfterSubmit);
            }else{
                this.appMsg.addErrorMessage("Please correct the errors below and try again.");
            }
        }
    }

    private async runValidationRules() {
        // run standard rules before save
        // these rules should not require validation
        if (!await this.taskDetailsComponent.validate(this.controller, this)) {
            return false;
        }

        return true;


    }

    public async post() {
        await this.doAction(this.saveUiAction.children[0], false);
        // await this.loadDataAsync(this.task.taskId);
    }

    async submitUiAction(action: DoUiActionDto<CmpTaskBaseDto>, redirectAfterSubmit: boolean = true) {

        //TODO move this to fulfillment module
        //if (action.uiActionVerb == "send_registration_link") {
        //    var result = await this.controller.validate();
        //    if (result.length > 0) {
        //        return;
        //    }
        //}
        this.busyService.on();
        try {
            const result = await this.api.post("Tasks", "DoTaskUiAction", action);
            // this.clearCommentFields();
            this.busyService.off();
            if (await this.taskDetailsComponent.afterActionSubmit(action.uiActionVerb)) {
                //const uiActionButton = this.taskActionService.actionButtons.find(o => o.key == action.uiActionVerb);
                if (redirectAfterSubmit) {
                    var redirectRoute = AureliaCookie.get('nav_stack');
                    if (redirectRoute) {
                        this.router.navigateToRoute(redirectRoute);
                        AureliaCookie.delete('nav_stack');
                        return;
                    }
                }
                await this.loadDataAsync(this.task.taskId);
                await this.taskDetailsComponent.initUi();
                this.updateUiActions();
            }
        } catch (e) {
            this.busyService.off();
            this.taskDetailsComponent.afterActionSubmit(action.uiActionVerb, e);
        }
    }


    async loadDataAsync(taskId) {
        this.busyService.on();
        return this.api.get("Tasks", "GetTaskDetailsScreenDataDto", { taskId: taskId })
            .then(async (result) => {
                const screenData = JSON.parse(result.response) as TaskDetailsScreenDataDto;
                this.request = screenData.request;
                this.task = screenData.task;
                this.originalTask = JSON.parse(JSON.stringify(this.task));
                this.activityStream = screenData.activityStream;
                this.assignedToUsers = screenData.assignedToUsers;


                this.saveUiAction = this.taskActionService.addUiActionFromTemplate(TaskActionService.saveActionTemplate);
                this.closeUiAction = this.taskActionService.addUiActionFromTemplate(TaskActionService.closeActionTemplate);
                this.startWorkAction = this.taskActionService.addUiActionFromTemplate(TaskActionService.startWorkActionTemplate);

                this.updateUiActions();
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    private updateUiActions() {
        this.startWorkAction.visible = this.task.active && this.task.state.value == TaskState.New;
        this.closeUiAction.visible = (this.taskDetailsComponent && this.taskDetailsComponent.showCloseAction)
            && (this.task.active && this.task.state.value != TaskState.New)
            && this.task.assignedTo.value == this.securityService.user.id;

            //console.log("SETTING this.closeUiAction.visible=" + this.closeUiAction.visible);

    }

    public onFulfillmentWidgetReady(){
        this.updateUiActions();
    }
}